/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IOnboardingData
  extends Array<{
    id: number;
    header: string;
    subHeader?: string;
    valuesHeader?: string;
    values: {
      valueId: number;
      name: string;
      value: string;
    }[];
  }> {}

interface IOnboardingSlice {
  onboardingPresets: any;
  isShowOnboardingModal: boolean;
  activeOnboardingModal:
    | 'onboardingPreviewModal'
    | 'onboardingPhoneVerifyModal'
    | 'onboardingSuccessModal'
    | 'onboardingSelfieModal'
    | 'onboardingPaymentProcessingModal'
    | 'onboardingComingSoonModal'
    | '';
  onboardingPreviewData: IOnboardingData;
  onboardingSuccessTitle: string;
  onboardingSuccessSubTitle: string;
  successModalRoute: string;
  successModalBtnTitle: string;
  onboardingApiData: any;
  onboardingApiResponse: any;
}

const initialState: IOnboardingSlice = {
  onboardingPresets: null,
  isShowOnboardingModal: false,
  activeOnboardingModal: '',
  onboardingPreviewData: [],
  onboardingSuccessTitle: '',
  onboardingSuccessSubTitle: '',
  successModalRoute: '',
  successModalBtnTitle: '',
  onboardingApiData: null,
  onboardingApiResponse: null
};

export const onboardingSlice = createSlice({
  name: 'onboarding',
  initialState,
  reducers: {
    setOnboardingPresets: (state: IOnboardingSlice, action: PayloadAction<any>) => {
      const { payload } = action;
      state.onboardingPresets = payload;
    },
    setIsShowOnboardingModal: (state: IOnboardingSlice, action: PayloadAction<boolean>) => {
      const { payload } = action;
      state.isShowOnboardingModal = payload;
    },
    setActiveOnboardingModal: (
      state: IOnboardingSlice,
      action: PayloadAction<
        | 'onboardingPreviewModal'
        | 'onboardingPhoneVerifyModal'
        | 'onboardingSuccessModal'
        | 'onboardingSelfieModal'
        | 'onboardingPaymentProcessingModal'
        | 'onboardingComingSoonModal'
        | ''
      >
    ) => {
      const { payload } = action;
      state.activeOnboardingModal = payload;
    },
    setOnboardingPreviewData: (state: IOnboardingSlice, action: PayloadAction<IOnboardingData>) => {
      const { payload } = action;
      state.onboardingPreviewData = payload;
    },
    setOnboardingSuccessTitle: (state: IOnboardingSlice, action: PayloadAction<string>) => {
      const { payload } = action;
      state.onboardingSuccessTitle = payload;
    },
    setOnboardingSuccessSubTitle: (state: IOnboardingSlice, action: PayloadAction<string>) => {
      const { payload } = action;
      state.onboardingSuccessSubTitle = payload;
    },
    setSuccessModalRoute: (state: IOnboardingSlice, action: PayloadAction<string>) => {
      const { payload } = action;
      state.successModalRoute = payload;
    },
    setSuccessModalBtnTitle: (state: IOnboardingSlice, action: PayloadAction<string>) => {
      const { payload } = action;
      state.successModalBtnTitle = payload;
    },
    setOnboardingApiData: (state: IOnboardingSlice, action: PayloadAction<any>) => {
      const { payload } = action;
      state.onboardingApiData = payload;
    },
    setOnboardingApiResponse: (state: IOnboardingSlice, action: PayloadAction<any>) => {
      const { payload } = action;
      state.onboardingApiResponse = payload;
    }
  }
});

const { actions, reducer } = onboardingSlice;

export const {
  setOnboardingPresets,
  setIsShowOnboardingModal,
  setActiveOnboardingModal,
  setOnboardingPreviewData,
  setOnboardingSuccessTitle,
  setOnboardingSuccessSubTitle,
  setSuccessModalRoute,
  setSuccessModalBtnTitle,
  setOnboardingApiData,
  setOnboardingApiResponse
} = actions;

export default reducer;
